import { Observable } from 'rxjs/Observable';
import { Timeline } from './../../../auth/_models/timeline';
import { StorageService } from './../../../auth/_services/storage.service';
import { ActivatedRoute } from '@angular/router';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { Component, OnInit } from '@angular/core';
import { Pet } from 'src/app/auth/_models/pet';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-my-pet-timeline',
  templateUrl: './my-pet-timeline.component.html',
  styleUrls: ['./my-pet-timeline.component.css']
})
export class MyPetTimelineComponent implements OnInit {

  pet: Pet;
  timelineItens: Observable<Timeline[]>;

  constructor(
    private _storageService: StorageService,
    private _route: ActivatedRoute,
    private _service: PetsService,
    private _tostr: ToastrService,
  ) { }

  ngOnInit() {

    this._route.parent.params.subscribe(params => {
      const uuid = params['id'];

      this.pet = new Pet({
        uuid: uuid
      });

      this.timelineItens = this._service.getTimeline(this.pet)
        .snapshotChanges().map(o => {
          return o.map(item => {
            const data = item.payload.doc.data();
            const itemuuid = item.payload.doc.id;

            // `pets/${this.pet.uuid}/photos/` + photoUuid;
            const pathReference = `pets/${uuid}/photos/` + data.photo;

            this._storageService.getPhotoUrl(pathReference).then(url => {
              data.photoUrl = url;
              console.log(uuid, url);
            });

            return new Timeline({ ...{ uuid: itemuuid }, ...data });
          });

        });

      this.timelineItens.subscribe(data => {
        console.log('data', data);

      });
    });

  }

  timelinePosition(i) {
    let position = 'left';
    if (i % 2 !== 0) {
      position = 'right';
    }
    return 'timeline-row timeline-row-' + position;
  }

  removePhoto(item) {
    console.log('Deletar Timeline: ', item.uuid);
    console.log('Deletar do Pet: ', this.pet.uuid);
    this._service.removeItemFromTimeline(this.pet, item)
      .then(() => {
        this._tostr.success('Foto removida com sucesso!');
      })
      .catch(error => {
        this._tostr.error('Erro ao deletar foto!');
      });
  }

}
